import type { Squad } from '../../../types';
import { DEFAULT_TZ, formatTimeInZone } from '../../../shared/utils/timezone';

/**
 * Completed squads can be archived without a cancellation warning. A squad
 * with no usable end date is treated as active/upcoming so an admin must make
 * the lifecycle choice explicitly.
 */
export function shouldConfirmArchiveInsteadOfCancel(squad: Partial<Squad>, now = new Date()): boolean {
  const timezone = String(squad.timezone || DEFAULT_TZ).trim() || DEFAULT_TZ;
  const today = formatTimeInZone(now, timezone, 'yyyy-MM-dd');
  const schedule = squad.schedule || {};
  const lastScheduledDate = String(schedule.mainDate || schedule.endDate || '').slice(0, 10);
  return !lastScheduledDate || lastScheduledDate >= today;
}
